exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-markdown-editor[data-v-d3139a30] .tui-editor-defaultUI .te-mode-switch,\n.j-markdown-editor[data-v-d3139a30] .tui-editor-defaultUI .tui-scrollsync {\n  line-height: 1.5;\n}\n", ""]);

// exports
